import React from 'react';
import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { Button, MinusIcon } from 'framework/ui/mui-builder';
import { TextInput, EnumDropdown } from 'framework/form';
import { IssueItem, IssueStatus } from './types';

const STATUS_OPTIONS = {
  ACTIVE: 'Active',
  CLOSED: 'Closed',
  POSTPONED: 'Postponed',
};

interface IssueItemComponentProps {
  issue: Partial<IssueItem>;
  index: number;
  onDescriptionChange: (index: number, value: string) => void;
  onStatusChange: (index: number, status: IssueStatus) => void;
  onRemove: (index: number) => void;
}

const IssueItemComponent: React.FC<IssueItemComponentProps> = ({
  issue,
  index,
  onDescriptionChange,
  onStatusChange,
  onRemove,
}) => {
  const isNew = issue.isNew === true;
  const elementId = issue.id ? String(issue.id) : `${index}`;

  return (
    <Box mb={1}>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid size={isNew ? 11 : 9.5}>
          {isNew ? (
            <TextInput
              source={`issue_${elementId}`}
              label="Issue"
              placeholder="Describe the issue"
              onChangeCallback={(inputData: any) => {
                onDescriptionChange(index, inputData[`issue_${elementId}`]);
              }}
              value={issue.description || ''}
            />
          ) : (
            <Box borderBottom={1} borderColor="divider" minHeight="38px" alignContent="center">
              <Typography variant="body1">{issue.description || 'No description'}</Typography>
            </Box>
          )}
        </Grid>

        {!isNew && (
          <Grid size={2.5}>
            <EnumDropdown
              source={`status_${elementId}`}
              label="Status"
              value={issue.status || 'ACTIVE'}
              onChangeCallback={(event: any) => {
                onStatusChange(index, event[`status_${elementId}`] as IssueStatus);
              }}
              options={STATUS_OPTIONS}
              placeholder="Select status"
            />
          </Grid>
        )}

        {isNew && (
          <Grid size={1} display="flex" alignItems="center" justifyContent="flex-end" mt={0.5}>
            <Button
              color="primary"
              variant="contained"
              sx={{ minWidth: 'auto', px: 1 }}
              onClick={() => onRemove(index)}
              size="small"
            >
              <MinusIcon sx={{ fill: 'common.white' }} />
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default IssueItemComponent;
